import React from 'react';
import { css } from '@emotion/core';
import chroma from 'chroma-js';
import A from '../../Anchor/Anchor';
import MetodiPagamento from '../../Icons/MetodiPagamento';
import Spedizionieri from '../../Icons/Spedizionieri_2';

import './BottomFooter.scss';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';

const BottomFooter = ({
  primaryColor,
  secondaryColor,
  datiFarmacia,
  footerVersion,
}) => {
  const BottomFooterStyle = css`
    &.version-1 {
      .container {
        max-width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        .pagamenti,
        .spedizioni {
          h2 {
            color: #ffff;
          }

          // svg {
          //   fill: #f8f8f8 !important;
          // }
        }
      }
      .container > .copy-social > .copy-footer h2 {
        color: #ffff;
      }
    }
    &.version-2 {
      .container > .info-spedizioni {
        .pagamenti,
        .spedizioni {
          // svg {
          //   fill: #222222 !important;
          // }
        }
      }
      .container > .copy-social > .copy-footer h2 {
        color: #000;
        font-weight: 400;
      }
    }
    &.version-3 {
      background-color: ${chroma(primaryColor)
        .darken(0.7) //valore precedente: 3
        .hex()};
      .container > .info-spedizioni {
        .pagamenti,
        .spedizioni {
          h2 {
            color: #ffff;
          }

          // svg {
          //   fill: #f8f8f8 !important;
          // }
        }
      }
      .container > .copy-social > .copy-footer h2 {
        color: #ffff;
      }
    }
  `;

  const footerBackground =
    footerVersion === 1
      ? chroma(secondaryColor)
          .darken(3.5)
          .hex()
      : footerVersion === 2
      ? '#f8f8f8'
      : chroma(primaryColor)
          .darken(0.7)
          .hex();

  return (
    <div
      className={`bottom-footer version-${footerVersion}`}
      css={BottomFooterStyle}
    >
      <div className="container">
        <div className="info-spedizioni">
          <div className="pagamenti">
            <h2>Pagamenti sicuri</h2>
            <MetodiPagamento background={footerBackground} />
          </div>
          <div className="spedizioni">
            <h2>Spedizioni rapide</h2>
            <Spedizionieri background={footerBackground} />
          </div>
        </div>
        <div className="copy-social">
          <div className="copy-footer">
            <div
              style={{
                fontSize: '12px',
                marginRight: '4px',
              }}
            >
              powered by:
            </div>
            <A href="https://www.farmakom.it/" target="_blank">
              {footerVersion !== 2 ? (
                <ImageDispatcher
                  // src="/static/images/farmakom-logo-dark-mode.png"
                  src="/static/images/farmakom-logo-dark-mode.webp"
                  alt="Logo Farmakom modalità tema colori scuro"
                />
              ) : (
                <ImageDispatcher
                  // src="/static/images/farmakom-logo-light-mode.png"
                  src="/static/images/farmakom-logo-light-mode.webp"
                  alt="Logo Farmakom modalità tema colori chiaro"
                />
              )}
            </A>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
